import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { lazy, Suspense, useEffect } from "react";
import Cursor from "@/components/Cursor";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import OpeningBanner from "@/components/OpeningBanner";
import { SiteSettingsProvider } from "@/lib/useSiteSettings";
import Home from "@/pages/Home";
import Expertise from "@/pages/Expertise";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Appointment from "@/pages/Appointment";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Referrer from "@/pages/Referrer";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (!pathname.startsWith("/journal/")) {
            // BlogPost already scrolls to top on mount; skip only there
        }
    }, [pathname]);
    return null;
}

function AnimatedRoutes() {
    const location = useLocation();
    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={location.pathname}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.55, ease: [0.2, 0.8, 0.2, 1] }}
            >
                <Routes location={location}>
                    <Route path="/" element={<Home />} />
                    <Route path="/domaines" element={<Expertise />} />
                    <Route path="/cabinet" element={<About />} />
                    <Route path="/journal" element={<Blog />} />
                    <Route path="/journal/:slug" element={<BlogPost />} />
                    <Route path="/rendez-vous" element={<Appointment />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/medecin" element={<Referrer />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </motion.div>
        </AnimatePresence>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <SiteSettingsProvider>
                    <Cursor />
                    <OpeningBanner />
                    <Navbar />
                    <ScrollToTop />
                    <AnimatedRoutes />
                    <Footer />
                </SiteSettingsProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
